import React from 'react';

import cn from 'classnames';

import Icon from '../icon/icon';

import ArrowLeft from './images/arrowleft.svg';

import css from './BackButton.css';

type Props = {
    type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
    icon?: React.ReactSVGElement;
    className?: string;
    onClick?: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
};

const BackButton: React.FC<React.PropsWithChildren<Props>> = ({
    type = 'button',
    icon,
    className,
    onClick,
}) => (
    <button className={cn(css.root, className)} type={type} onClick={onClick}>
        <Icon glyph={icon || ArrowLeft} />
    </button>
);

export default React.memo(BackButton);
